import { render } from "./video-feed.vue?vue&type=template&id=c1752502"
import script from "./video-feed.vue?vue&type=script&lang=js"
export * from "./video-feed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__